const PrivacyPageDe = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Datenschutzerklärung</h1>
      
      <div className="prose max-w-none text-gray-600">
        <div className="mb-8">
          <p className="mb-4">
            Ihre Privatsphäre ist uns bei Map Prints wichtig. Wir haben diese Richtlinie erstellt, um klar zu erläutern, 
            wie wir Ihre Informationen sammeln, nutzen und schützen, wenn Sie mapprints.de besuchen oder unsere Dienste nutzen.
          </p>

          <p className="mb-4">
            Haben Sie Fragen? Wir sind für Sie da! Kontaktieren Sie uns jederzeit unter info@mapprints.de oder info.mapprints@gmail.com.
          </p>

          <div className="bg-gray-50 p-4 rounded-xl mb-6">
            <p className="text-sm">
              Zuletzt aktualisiert: 5. Mai 2026 | Verfügbar in: Deutsch, Englisch
            </p>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Kurzübersicht</h2>
          <p className="mb-4">
            Hier erfahren Sie das Wichtigste über den Umgang mit Ihren Daten:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Wir verwenden Cookies, um Ihr Browsing-Erlebnis zu verbessern (z.B. Speichern Ihrer Einstellungen)</li>
            <li>Wir speichern Strava- und GPX-Aktivitätsdaten, wenn Sie individuelle Drucke mit Aktivitäten erstellen</li>
            <li>Wir nutzen vertrauenswürdige Anbieter für Zahlungen</li>
            <li>Wir respektieren und schützen Ihre Strava-Daten</li>
          </ul>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ihre Rechte nach DSGVO</h2>
          <p className="mb-4">
            Als EU-basiertes Unternehmen folgen wir strengen Datenschutzregeln. Wir sammeln und verwenden 
            Ihre Informationen nur, wenn:
          </p>
          
          <ul className="list-disc pl-6 mb-6">
            <li>Wir sie zur Erfüllung Ihrer Bestellung benötigen</li>
            <li>Sie uns Ihre Einwilligung gegeben haben</li>
            <li>Es für unsere berechtigten Geschäftsinteressen erforderlich ist</li>
            <li>Wir gesetzlich dazu verpflichtet sind</li>
          </ul>

          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <h3 className="font-semibold mb-2">Ihre Datenschutzrechte</h3>
            <p className="mb-3">Als EWR-Resident können Sie:</p>
            <ul className="list-disc pl-6">
              <li>Ihre Informationen einsehen oder aktualisieren</li>
              <li>Die Löschung Ihrer Daten beantragen</li>
              <li>Der Nutzung Ihrer Daten widersprechen</li>
              <li>Die Datenverarbeitung einschränken</li>
              <li>Ihre Daten übertragen</li>
              <li>Ihre Einwilligung widerrufen</li>
            </ul>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Wie wir Cookies verwenden</h2>
          <p className="mb-4">
            Cookies helfen uns, Ihr Erlebnis zu verbessern. Diese kleinen Dateien speichern Ihre Präferenzen und 
            helfen uns zu verstehen, wie Sie unsere Website nutzen. Hier erfahren Sie, wofür wir sie einsetzen:
          </p>

          <ul className="list-disc pl-6 mb-4">
            <li>Speichern Ihrer Präferenzen</li>
          </ul>

          <p className="mb-4">
            Keine Sorge - Cookies können nicht auf Ihren Computer zugreifen oder Informationen abrufen, die Sie nicht freigegeben haben.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Website-Analyse</h2>
          <p className="mb-4">
            Wir verwenden Google Analytics 4 (Anbieter: Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Irland),
            um zu verstehen, wie Sie unsere Website nutzen, und unseren Service zu verbessern.
            Google Analytics kann dabei Informationen wie Ihre IP-Adresse, Browsertyp, besuchte Seiten und Verweilzeiten
            verarbeiten. Eine Übermittlung in die USA durch Google ist nicht ausgeschlossen.
          </p>
          <p className="mb-4">
            <strong>Einwilligungspflicht:</strong> Das Google-Analytics-Skript (gtag.js) wird erst nach Ihrer ausdrücklichen
            Einwilligung im Cookie-Banner geladen. Vor der Einwilligung wird keinerlei Verbindung zu Google-Servern aufgebaut.
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO sowie § 25 Abs. 1 TTDSG. Sie können Ihre Einwilligung jederzeit
            über den Link „Cookie-Einstellungen“ im Footer widerrufen.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Login mit Google</h2>
          <p className="mb-4">
            Auf den Login- und Registrierungsseiten bieten wir „Login mit Google“ an (Google Ireland Ltd.). Das dafür
            erforderliche Skript <code>accounts.google.com/gsi/client</code> wird ausschließlich auf diesen Seiten geladen –
            nicht auf der Startseite oder anderen Bereichen der Website. Erst wenn Sie aktiv auf den Google-Login-Button
            klicken, werden Daten an Google übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)
            bzw. lit. a (Einwilligung mit Klick auf den Button).
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Karten und Kartenkacheln (Tile-Server)</h2>
          <p className="mb-4">
            Zur Darstellung der Karten in unserer Anwendung laden wir Kartenkacheln von folgenden Drittanbietern. Beim Laden
            wird Ihre IP-Adresse technisch notwendig an den jeweiligen Anbieter übertragen. Rechtsgrundlage ist Art. 6 Abs. 1
            lit. f DSGVO (berechtigtes Interesse an der Bereitstellung der Kartenfunktion):
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>
              <strong>OpenStreetMap</strong> – OpenStreetMap Foundation, St John’s Innovation Centre, Cowley Road, Cambridge,
              CB4 0WS, UK. <a href="https://osmfoundation.org/wiki/Privacy_Policy" className="underline" target="_blank" rel="noreferrer">Datenschutzerklärung</a>.
            </li>
            <li>
              <strong>OpenTopoMap</strong> – ehrenamtliches Projekt auf Basis von OpenStreetMap-Daten.
              <a href="https://opentopomap.org/about" className="underline ml-1" target="_blank" rel="noreferrer">Über OpenTopoMap</a>.
            </li>
            <li>
              <strong>CARTO</strong> (Positron, Voyager, Dark Matter) – CARTO Inc., 201 Moore Street, Brooklyn, NY 11206, USA.
              <a href="https://carto.com/privacy/" className="underline ml-1" target="_blank" rel="noreferrer">Datenschutzerklärung</a>.
            </li>
            <li>
              <strong>Esri</strong> (Satellitenansicht „World Imagery“) – Esri Inc., 380 New York Street, Redlands, CA 92373, USA.
              <a href="https://www.esri.com/en-us/privacy/overview" className="underline ml-1" target="_blank" rel="noreferrer">Datenschutzerklärung</a>.
            </li>
            <li>
              <strong>Thunderforest</strong> (Transport, Landscape, Outdoors, Pioneer, Atlas u.a.) – Gravitystorm Limited,
              UK. <a href="https://www.thunderforest.com/privacy/" className="underline" target="_blank" rel="noreferrer">Datenschutzerklärung</a>.
            </li>
            <li>
              <strong>Mapbox</strong> (Streets, Outdoors, Light, Dark, Satellite) – Mapbox Inc., 740 15th Street NW, 5th Floor,
              Washington, DC 20005, USA.
              <a href="https://www.mapbox.com/legal/privacy" className="underline ml-1" target="_blank" rel="noreferrer">Datenschutzerklärung</a>.
            </li>
          </ul>
          <p className="mb-4">
            Bei Anbietern mit Sitz außerhalb des EWR (USA, UK) erfolgt die Übermittlung auf Grundlage der EU-Standardvertrags­klauseln
            bzw. – im Fall des Vereinigten Königreichs – des UK-Angemessenheits­beschlusses der EU-Kommission.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ortssuche (Nominatim)</h2>
          <p className="mb-4">
            Für die Ortssuche im Karteneditor verwenden wir den Nominatim-Dienst der OpenStreetMap Foundation. Bei einer
            Suchanfrage werden Ihre IP-Adresse und der Suchbegriff an Nominatim übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1
            lit. f DSGVO.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Umgang mit Ihren Zahlungsinformationen</h2>
          <p className="mb-4">
            Wir nutzen Stripe, einen vertrauenswürdigen Zahlungsdienstleister, für alle finanziellen Transaktionen. Weitere Informationen zur Zahlungssicherheit finden Sie in der Datenschutzerklärung 
            von Stripe. Der gesamte Datenverkehr auf  https://mapprints.de ist SSL-verschlüsselt.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Bestellinformationen</h2>
            <p className="mb-4">
              Derzeit generieren und liefern wir nur digitale Karten. Für digitale Karten zum selberdrucken werden keine personenbezogenen Daten von https://mapprints.de benötigt.
            </p>
            <p className="mb-4">
              In Zukunft, wenn wir gedruckte Bilder einführen, werden wir Versandinformationen wie Ihren Namen und 
              Ihre Lieferadresse benötigen. Wir werden diese Datenschutzerklärung entsprechend aktualisieren, 
              sobald dieser Service verfügbar wird.
            </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ihre Aktivitätsdaten</h2>
          <p className="mb-4">
            Wenn Sie einen individuellen Druck erstellen, speichern wir Ihre Designdaten sicher. Dazu gehören:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Hochgeladene GPX- oder FIT-Dateien</li>
            <li>Strava-Aktivitäten, die Sie geteilt haben</li>
            <li>Individuelle Design-Präferenzen</li>
          </ul>
          <p className="mb-4">
            Wir verwenden diese Informationen ausschließlich zur Erstellung Ihres Drucks und werden sie niemals an Dritte weitergeben.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Geltungsbereich dieser Richtlinie</h2>
          <p className="mb-4">
            Diese Datenschutzerklärung gilt ausschließlich für unsere Website (mapprints.de) und umfasst keine 
            Offline-Interaktionen oder andere Websites.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Ihre Zustimmung</h2>
          <p className="mb-4">
            Durch die Nutzung von Map Prints stimmen Sie dieser Datenschutzerklärung zu. Wir empfehlen Ihnen, 
            sie regelmäßig zu überprüfen, da sie von Zeit zu Zeit aktualisiert werden kann.
          </p>
        </div>
      </div>
    </div>
  );
};
  
  const PrivacyPageEn = () => {
    return (
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        
        <div className="prose max-w-none text-gray-600">
          <div className="mb-8">
            <p className="mb-4">
              Your privacy is important to us at Map Prints. We've created this policy to clearly explain 
              how we collect, use, and protect your information when you visit mapprints.de or use our services.
            </p>
  
            <p className="mb-4">
              Have questions? We're here to help! Reach out to us anytime at info@mapprints.de or info.mapprints@gmail.com.
            </p>
  
            <div className="bg-gray-50 p-4 rounded-xl mb-6">
              <p className="text-sm">
                Last updated: May 5, 2026 | Available in: German, English
              </p>
            </div>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Quick Overview</h2>
            <p className="mb-4">
              Here's what you need to know about how we handle your data:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>We use cookies to improve your browsing experience (eg. store your settings)</li>
              <li>We store Strava- and GPX-activity data in our database when you create custom prints with activities</li>
              <li>We use a trusted payment providers for payments</li>
              <li>We respect and protect your Strava data</li>
            </ul>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Your Rights Under GDPR</h2>
            <p className="mb-4">
              As a company based in the EU, we follow strict data protection rules. We only collect and use 
              your information when:
            </p>
            
            <ul className="list-disc pl-6 mb-6">
              <li>We need it to fulfill your order</li>
              <li>You've given us permission</li>
              <li>It's necessary for our legitimate business interests</li>
              <li>We're required by law</li>
            </ul>
  
            <div className="bg-blue-50 p-4 rounded-xl mb-6">
              <h3 className="font-semibold mb-2">Your Data Rights</h3>
              <p className="mb-3">As an EEA resident, you can:</p>
              <ul className="list-disc pl-6">
                <li>Access or update your information</li>
                <li>Request deletion of your data</li>
                <li>Object to how we use your data</li>
                <li>Restrict data processing</li>
                <li>Transfer your data</li>
                <li>Withdraw your consent</li>
              </ul>
            </div>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">How We Use Cookies</h2>
            <p className="mb-4">
              Cookies help us make your experience better. These small files remember your preferences and 
              help us understand how you use our website. Here's what we use them for:
            </p>
  
            <ul className="list-disc pl-6 mb-4">
              {/* <li>Analyzing which pages are most useful to visitors</li> */}
              {/* <li>Improving website performance</li> */}
              <li>Remembering your preferences</li>
            </ul>
  
            <p className="mb-4">
              Don't worry - cookies can't access your computer or any information you haven't chosen to share.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Website Analytics</h2>
            <p className="mb-4">
              We use Google Analytics 4 (provider: Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Ireland) to
              understand how you use our website and to improve our service. Google Analytics may process information such
              as your IP address, browser type, pages visited and time spent on the site. Transfers to the United States by
              Google cannot be ruled out.
            </p>
            <p className="mb-4">
              <strong>Consent required:</strong> The Google Analytics script (gtag.js) is only loaded after you give your
              explicit consent in the cookie banner. Before you consent, no connection to Google servers is established.
              The legal basis is Art. 6(1)(a) GDPR and § 25(1) TTDSG. You can withdraw your consent at any time via the
              "Cookie Settings" link in the footer.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Sign in with Google</h2>
            <p className="mb-4">
              On the login and registration pages we offer "Sign in with Google" (Google Ireland Ltd.). The required script
              <code> accounts.google.com/gsi/client </code> is loaded only on those pages — not on the landing page or other
              parts of the site. Data is only transmitted to Google once you actively click the Google sign-in button. The
              legal basis is Art. 6(1)(b) GDPR (steps prior to entering a contract) or (a) (consent expressed by clicking
              the button).
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Map tiles (third-party tile servers)</h2>
            <p className="mb-4">
              To display maps in our application we load map tiles from the following third-party providers. Loading a tile
              technically requires transmitting your IP address to the respective provider. The legal basis is Art. 6(1)(f)
              GDPR (legitimate interest in providing the map functionality):
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>
                <strong>OpenStreetMap</strong> – OpenStreetMap Foundation, St John’s Innovation Centre, Cowley Road,
                Cambridge, CB4 0WS, UK.
                <a href="https://osmfoundation.org/wiki/Privacy_Policy" className="underline ml-1" target="_blank" rel="noreferrer">Privacy policy</a>.
              </li>
              <li>
                <strong>OpenTopoMap</strong> – volunteer project based on OpenStreetMap data.
                <a href="https://opentopomap.org/about" className="underline ml-1" target="_blank" rel="noreferrer">About OpenTopoMap</a>.
              </li>
              <li>
                <strong>CARTO</strong> (Positron, Voyager, Dark Matter) – CARTO Inc., 201 Moore Street, Brooklyn, NY 11206,
                USA. <a href="https://carto.com/privacy/" className="underline" target="_blank" rel="noreferrer">Privacy policy</a>.
              </li>
              <li>
                <strong>Esri</strong> (Satellite "World Imagery") – Esri Inc., 380 New York Street, Redlands, CA 92373, USA.
                <a href="https://www.esri.com/en-us/privacy/overview" className="underline ml-1" target="_blank" rel="noreferrer">Privacy policy</a>.
              </li>
              <li>
                <strong>Thunderforest</strong> (Transport, Landscape, Outdoors, Pioneer, Atlas, etc.) – Gravitystorm Limited,
                UK. <a href="https://www.thunderforest.com/privacy/" className="underline" target="_blank" rel="noreferrer">Privacy policy</a>.
              </li>
              <li>
                <strong>Mapbox</strong> (Streets, Outdoors, Light, Dark, Satellite) – Mapbox Inc., 740 15th Street NW, 5th
                Floor, Washington, DC 20005, USA.
                <a href="https://www.mapbox.com/legal/privacy" className="underline ml-1" target="_blank" rel="noreferrer">Privacy policy</a>.
              </li>
            </ul>
            <p className="mb-4">
              For providers established outside the EEA (USA, UK), transfers are based on the EU Standard Contractual
              Clauses or — in the case of the United Kingdom — on the UK adequacy decision adopted by the European
              Commission.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Place search (Nominatim)</h2>
            <p className="mb-4">
              For place search inside the map editor we use the Nominatim service operated by the OpenStreetMap Foundation.
              When you submit a query, your IP address and the search term are transmitted to Nominatim. The legal basis
              is Art. 6(1)(f) GDPR.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Handling Your Payment Information</h2>
            <p className="mb-4">
              We use Stripe, a trusted payment processor, to handle all financial transactions. For more information about payment security, 
              please check Stripe's Privacy Policy. All traffic on mapprints.de is secured via SSL.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Order Information</h2>
              <p className="mb-4">
                Currently, we only generate and deliver digital images. No personal information 
                is required for digital purchases on https://mapprints.de.
              </p>
              <p className="mb-4">
                In the future, when we introduce printed images, we will require shipping information 
                such as your name and delivery address. We'll update this privacy policy accordingly 
                when this service becomes available.
              </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Your Activity Data</h2>
            <p className="mb-4">
              When you create a custom print, we store your design data securely. This includes:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Uploaded GPX or FIT files</li>
              <li>Strava activities you've shared</li>
              <li>Custom design preferences</li>
            </ul>
            <p className="mb-4">
              We use this information solely to create your print and will never share it with third parties.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Scope of This Policy</h2>
            <p className="mb-4">
              This privacy policy applies exclusively to our website (mapprints.de) and doesn't cover 
              offline interactions or other websites.
            </p>
          </div>
  
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">Your Agreement</h2>
            <p className="mb-4">
              By using Map Prints, you agree to this privacy policy. We encourage you to review it 
              periodically, as it may be updated from time to time.
            </p>
          </div>
        </div>
      </div>
    );
  };

export {PrivacyPageDe, PrivacyPageEn};  